import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContainerSwitch } from './styles';

type SwitchButtonProps = {
  id?: string;
  label?: string;
  isChecked: boolean;
  isRow?: boolean;
  isDisabled?: boolean;
  handleInputChange: (checked: boolean) => void;
};

const SwitchButton: React.FC<SwitchButtonProps> = ({
  id = 'switch-id',
  label,
  isChecked,
  isRow = false,
  isDisabled = false,
  handleInputChange,
}) => {
  const [checked, setChecked] = useState(isChecked);
  const { t } = useTranslation();

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked;
    setChecked(newValue);
    handleInputChange(newValue);
  };

  return (
    <ContainerSwitch
      htmlFor={id}
      checked={checked}
      title={
        checked
          ? String(t('screens.registerProduct.marked'))
          : String(t('screens.registerProduct.unchecked'))
      }
      isRow={isRow}
      isDisabled={isDisabled}
    >
      {label && <div className="label">{label}</div>}
      <div className="switchButtonContainer">
        <div className="circle" />
        <div className="switch-content">
          <input
            id={id}
            type="checkbox"
            checked={checked}
            onChange={onChangeValue}
            disabled={isDisabled}
          />
        </div>
      </div>
    </ContainerSwitch>
  );
};

export default SwitchButton;
